module.exports = __webpack_public_path__ + "media/images/application/template/logos/air-force-9b347ce01a21db59bead0985e148d3bb.png";